import { EntityId } from "@jackfruit/common"
import { ActionCreatorWithPayload, PayloadAction } from "@reduxjs/toolkit"
import { VNZSessionImage } from "~/interfaces/entities/VNZSessionImage"
import { createEntitySlice } from "../createEntitySlice"
import { EnhancedEntityState } from "../store"

export interface VNZSessionImagesState
  extends EnhancedEntityState<VNZSessionImage> {
  isProcessing: boolean
  hasBeenProcessed: boolean
  hasError: boolean
  printProduct?: EntityId
  promoCodes?: string[]
}

interface VNZSessionImagesActions {
  setIsProcessing: ActionCreatorWithPayload<boolean>
  setHasBeenProcessed: ActionCreatorWithPayload<boolean>
  processVNZSessionImages: ActionCreatorWithPayload<void>
  hasError: ActionCreatorWithPayload<boolean>
  setPrintProduct: ActionCreatorWithPayload<number | string>
  setPromoCodes: ActionCreatorWithPayload<string[]>
}

const { slice, selectors: vnzSessionImagesSelectors } =
  createEntitySlice<VNZSessionImage>(
    "VNZSessionImages",
    {},
    {
      isProcessing: false,
      hasBeenProcessed: false,
      hasError: false,
      printProduct: undefined,
      promoCodes: [],
    },
    {
      setIsProcessing(state, action: PayloadAction<boolean>) {
        state.isProcessing = action.payload
      },
      setHasBeenProcessed(state, action: PayloadAction<boolean>) {
        state.hasBeenProcessed = action.payload
      },
      setHasError(state, action: PayloadAction<boolean>) {
        state.hasError = action.payload
      },
      setPrintProduct(state, action: PayloadAction<number | string>) {
        state.printProduct = action.payload
      },
      setPromoCodes(state, action: PayloadAction<string[]>) {
        state.promoCodes = action.payload
      },
      processVNZSessionImages(state) {},
    }
  )

const vnzSessionImages = {
  ...slice,
  actions: slice.actions as typeof slice.actions & VNZSessionImagesActions,
}

export { vnzSessionImages, vnzSessionImagesSelectors }
